export default {
  Urna: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "urna"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Urna.js
// module id = LhH3
// module chunks = 18